import React from "react";
import { Box, Typography, Paper, Tabs, Tab, Divider } from "@mui/material";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import DescriptionIcon from "@mui/icons-material/Description";
import CodeIcon from "@mui/icons-material/Code";

// interns scriptrunner - Helper to determine language for syntax highlighting
const getLanguage = (fileName) => {
  if (!fileName) return "text";
  const ext = fileName.split(".").pop().toLowerCase();
  if (ext === "py") return "python";
  if (ext === "json") return "json";
  if (ext === "js") return "javascript";
  if (ext === "sh") return "bash";
  return "text";
};

// interns scriptrunner - FilePreviewV2 component for viewing script contents during execution
const FilePreviewV2 = ({ files, selectedFile, onFileChange }) => {
  if (!files || Object.keys(files).length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: "center", bgcolor: "#f5f5f5" }}>
        <Typography color="textSecondary">
          No files available for preview.
        </Typography>
      </Paper>
    );
  }

  const fileNames = Object.keys(files).sort();
  const currentFileIndex = fileNames.indexOf(selectedFile);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* interns scriptrunner - File selection tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#fff" }}>
        <Tabs
          value={currentFileIndex !== -1 ? currentFileIndex : 0}
          onChange={(_, newValue) => onFileChange(fileNames[newValue])}
          variant="scrollable"
          scrollButtons="auto"
        >
          {fileNames.map((name) => (
            <Tab
              key={name}
              label={name}
              icon={name.endsWith(".py") ? <CodeIcon /> : <DescriptionIcon />}
              iconPosition="start"
              sx={{ textTransform: "none", minHeight: 48 }}
            />
          ))}
        </Tabs>
      </Box>

      {/* interns scriptrunner - Code viewer panel */}
      <Paper
        elevation={0}
        sx={{
          flexGrow: 1,
          bgcolor: "#1e1e1e",
          overflow: "hidden",
          border: "1px solid #333",
          borderTop: "none",
          borderRadius: "0 0 8px 8px",
        }}
      >
        <Box
          sx={{
            p: 1,
            bgcolor: "#333",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#aaa", ml: 1, fontFamily: "monospace" }}
          >
            Previewing: {selectedFile}
          </Typography>
          <Typography variant="caption" sx={{ color: "#888", mr: 1 }}>
            Read-only Mode
          </Typography>
        </Box>
        <Divider sx={{ bgcolor: "#444" }} />
        <Box sx={{ height: "500px", overflow: "auto" }}>
          <SyntaxHighlighter
            language={getLanguage(selectedFile)}
            style={vscDarkPlus}
            customStyle={{
              margin: 0,
              padding: "20px",
              fontSize: "0.85rem",
              backgroundColor: "transparent",
            }}
            showLineNumbers={true}
          >
            {files[selectedFile] || ""}
          </SyntaxHighlighter>
        </Box>
      </Paper>
    </Box>
  );
};

export default FilePreviewV2;
